export default __webpack_public_path__ + "253fd7a1ebd03ad68d1cd16bbcad915d.png";